import _ from 'lodash'
import moment from 'moment';

export const formatUserName = (firstName, lastName) => {
  return _.compact([firstName, lastName]).join(' ')
}

export const formatFeedCardDate = (date) => {
  return moment(date).format("MMM D, YYYY");
};